import React from 'react'
import CSSModules from 'helpers/CSSModulesUtil'
import Select from 'react-select'
import styles from './styles.scss'

const Input = (props) => {
  const { title, source, values, onChange, multiSelectable } = props

  return (
    <Select
      options={source}
      value={values}
      multi={multiSelectable}
      onChange={onChange}
      placeholder={`Select ${title}...`}
    />
  )
}

export default CSSModules(styles)(Input)